import { render, staticRenderFns } from "./RemindModal.vue?vue&type=template&id=0a727cec&scoped=true&"
import script from "./RemindModal.vue?vue&type=script&lang=js&"
export * from "./RemindModal.vue?vue&type=script&lang=js&"
import style0 from "./RemindModal.vue?vue&type=style&index=0&id=0a727cec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a727cec",
  null
  
)

export default component.exports